<template>
  <div>
    <ContentTop>
      <img
        src="../assets/images/down.png"
        alt=""
      />
      <span>下载报告</span>
    </ContentTop>
    <!-- <ARow>
      <ACol :span="18" offset="3"> -->
        <div class="step">
          <a-Card>
            <a-form layout="inline" :form="form" @submit="handleSubmit">
              <a-form-item label="订单编号">
                <a-input
                  v-decorator="[
                    'transactionId',
                    {
                      initialValue: transactionId,
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item>
                <a-button type="primary" html-type="submit"> 查询报告 </a-button>
              </a-form-item>
              <a-form-item>
                <div class="Order pull-left">
                  注意 ： 请慎重记录并保管好您的
                  <font color="red">订单号</font> 以便日后查询，离开此页则不再显示
                  <a class="WeChat-order" href="javascript:;">
                    <img src="../assets/images/weixin.png" />微信订单编号？
                    <span
                    ><img src="../assets/images/wx_out_trade_num.png" alt="" />
                    </span>
                  </a>
                  <a class="Alipay-order" href="javascript:;">
                    <img src="../assets/images/zhifubao.png" />支付宝订单编号？
                    <span
                    ><img
                      src="../assets/images/ali_out_trade_num.png"
                      alt=""
                    /></span>
                  </a>
                </div>
              </a-form-item>
            </a-form>
            <ADivider />
            <a-table :columns="columns" :data-source="result" rowKey="transactionId">
              <template v-slot:checkStatus="text">
                <span v-if="text === 'COMPLETED'">检测完成</span>
                <span v-else>检测中</span>
              </template>
              <template v-slot:action="text,record">
                <a
                  v-if="record.checkStatus === 'COMPLETED'"
                  @click="
                    dowZip(`/thesisCheck/api/trade/downReport/${record.tradeId}`)
                  "
                >下载</a
                >
              </template>
            </a-table>
            <a-alert
              style="margin-top: 30px" 
              message="温馨提示：请确认输入订单编号正确或已成功提交检测，并在七天内及时下载检测报告。" 
              type="warning" 
              show-icon 
              banner
            />
          </a-Card>
        </div>
      <!-- </ACol>
    </ARow> -->
  </div>
</template>

<script>
import ContentTop from '@/components/ContentTop'
import { Form, Input, Button, Card, Divider, Alert, Table } from 'ant-design-vue'
import axios from 'axios'

const columns = [
  {
    title: '订单号',
    dataIndex: 'transactionId',
    key: 'transactionId',
  },
  {
    title: '论文标题',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: '作者',
    dataIndex: 'author',
    key: 'author',
  },
  {
    title: '状态结果',
    dataIndex: 'checkStatus',
    key: 'checkStatus',
    scopedSlots: { customRender: 'checkStatus' },
  },
  {
    title: '提交时间',
    key: 'checkTime',
    dataIndex: 'checkTime',
  },
  {
    title: '报告下载',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  components: {
    // ARow:Row,
    // ACol:Col,
    AForm: Form,
    AFormItem: Form.Item,
    AInput: Input,
    AButton: Button,
    ACard: Card,
    ADivider: Divider,
    ATable: Table,
    AAlert: Alert,
    ContentTop,
  },

  data () {
    return {
      transactionId: this.$route.params.transactionId || undefined,
      result: [],
      columns,
    }
  },
  created () {
    if (this.transactionId) {
      this.$store.dispatch('check/findDataByid', {
        payload: {
          transactionId: this.transactionId,
        },
        callback: (res) => {
          this.result = res.data && res.data.list || []
        }
      })
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'customized_form_controls' })
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.transactionId) {
            this.$store.dispatch('check/findDataByid', {
              payload: values,
              callback: (res) => {
                this.result = res.data && res.data.list || []
              }
            })
          } else {
            this.result = []
          }
        }
      })
    },
    dowZip (url, fileName) {
      axios({
        method: 'GET',
        url,
        responseType: 'blob'
      }).then(response => {
        if (navigator.msSaveBlob) {
          // deal with IE 11, data是第一步toBlob的结果值
          window.navigator.msSaveOrOpenBlob(response.data, `${fileName}.zip`)
        }
        else {
          const blob = new Blob([response.data], { type: 'application/zip' })
          const url = window.URL.createObjectURL(blob)
          window.location.href = url
        }
      }).catch(error => this.$message.error(error))
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.ant-alert-warning {
  background-color: #fff;
  ::v-deep .ant-alert-message {
    color: #ffb967 !important;
  }
}


.Order a {
  color: #525252;
  position: relative;
  margin-left: 40px;
}
.Order a:first-child {
  margin-left: 0;
}
.Order img {
  padding-right: 10px;
}
.Order span {
  position: absolute;
  top: 30px;
  right: -200px;
  display: none;
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 10px 2px #efefef;
  z-index: 2;
}
.Order a:hover span {
  display: block;
}
.Order span {
  position: absolute;
  top: 30px;
  right: -200px;
  display: none;
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 10px 2px #efefef;
  z-index: 2;
}

.Order span:before {
  position: absolute;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid #efefef;
  content: ' ';
  display: block;
  width: 0;
  height: 0;
  top: -10px;
  right: 280px;
}
.Order span:after {
  border-bottom: 9px solid #fff;
  top: -8px;
}
</style>
